import {Cloneable} from "@/types";
import {SubtitleStyle, defaultSubtitleStyle} from "./SubtitleStyle";

export type {SubtitleStyle};
export {defaultSubtitleStyle};

export class Subtitle implements Cloneable {
    id: string;
    startTimeMs: number;
    endTimeMs: number;
    text: string;
    deleted?: boolean;
    style: SubtitleStyle;

    constructor(data: {
        id: string;
        startTimeMs: number;
        endTimeMs: number;
        text: string;
        deleted?: boolean;
        style?: SubtitleStyle;
    }) {
        this.id = data.id;
        this.startTimeMs = data.startTimeMs;
        this.endTimeMs = data.endTimeMs;
        this.text = data.text;
        this.deleted = data.deleted ?? false;
        this.style = data.style ?? {};
    }

    get startTimeSeconds(): number {
        return this.startTimeMs / 1000;
    }

    get endTimeSeconds(): number {
        return this.endTimeMs / 1000;
    }

    get durationSeconds(): number {
        return (this.endTimeMs - this.startTimeMs) / 1000;
    }

    clone(): this {
        return new Subtitle({
            id: this.id,
            startTimeMs: this.startTimeMs,
            endTimeMs: this.endTimeMs,
            text: this.text,
            deleted: this.deleted,
            style: {...this.style}
        }) as this;
    }
}
